export default "__VITE_ASSET__DPEzEex2__"